import type { Permission } from '@ztechapps/common.contract'

export const routePermissions = {
  canView: {
    value: 'route.canView',
    label: 'Can View',
    description: 'No modification can be done to the route, only viewing of details.',
  } satisfies Permission,
  canEdit: {
    value: 'route.canEdit',
    label: 'Can Edit',
    description: 'Can modify the records for all fields of route',
  } satisfies Permission,
  canDelete: {
    value: 'route.canDelete',
    label: 'Can Delete',
    description: 'Can delete the records for all fields of route. This will delete entire record and cannot be recovered.',
  } satisfies Permission,
}
